export const templateHtmlCodes = {
  COMPLETE_SUMMARY: 'COMEXP',
  COMPLETE_SUMMARY_VO: 'COMPEXP_VO',
  PREDELIVERY: 'PREDEL'
}
